import {combineReducers} from 'redux';
import {getSuccessActionType} from '../utils';
import {getErrorReducer, getStatusReducer} from './utils/generators';
import {CREATE_REPORT, DELETE_REPORT, FETCH_STUDENT_REPORTS} from '../constants/report';
import {END_STUDENT_COURSE, START_STUDENT_COURSE} from '../constants/student-course';

function data(state = [], action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_STUDENT_REPORTS):
      return action.payload;

    case getSuccessActionType(CREATE_REPORT):
      return [...state, action.payload];

    case getSuccessActionType(DELETE_REPORT):
      return state.filter(report => report.id !== action.data.reportId);

    case getSuccessActionType(START_STUDENT_COURSE):
    case getSuccessActionType(END_STUDENT_COURSE):
      return [];

    default:
      return state;
  }
}

export default combineReducers({
  status: getStatusReducer([FETCH_STUDENT_REPORTS]),
  error: getErrorReducer([FETCH_STUDENT_REPORTS]),
  data
});
